// Importar librerías
import React, { useContext, useEffect, useState } from 'react';
import moment from 'moment';
import { Button } from 'antd';

// Importar context de firebase y user
import { FirebaseContext, AuthUserContext } from '../../../context';

// Importar otros componentes
import { ReactComponent as DonwloadIcon } from './../assets/donwload.svg';

// Definir formato de fecha
const DATE_FORMAT = 'DD/MM/YYYY';

/**
 *
 * @param {*} x
 * Coloca puntos a un valor númerico de entrada (Definir Mejor)
 */
const numberWithPoints = (x) => {
  return x.toLocaleString();
};

/**
 *
 * @param {*} application
 * @param {*} executiveUser
 * Regresa la respuesta dada por el banco.
 */
const getBankAnswer = (application, executiveUser) => {
  if (!application) return null;

  const winnerAnswer = application.get('winner');

  if (winnerAnswer.executiveId !== executiveUser.uid) return null;
  return winnerAnswer;
};

const TakenApplicationAnswerShowConsumo = ({ application, reject, report }) => {
  // Obtener información del context de firebase y user
  const firebase = useContext(FirebaseContext);
  const authUser = useContext(AuthUserContext);

  // Definir state
  // null o la respuesta
  const [currentBankAnswer] = useState(getBankAnswer(application, authUser));
  const [currentFileAnswer, setCurrentFileAnswer] = useState([]);

  // Definir effect para setear la repuesta dada por el banco
  useEffect(() => {
    const loadBankAnswerFiles = async () => {
      if (currentBankAnswer && currentBankAnswer.status === 'offer') {
        const { answerFiles } = currentBankAnswer.answer;
        const currentFiles = answerFiles.map(firebase.getDownloadURL);
        const aux = await Promise.all(currentFiles.map((p) => p.catch((e) => null)));
        const aux2 = aux.map((d, i) => {
          return {
            uid: d,
            name: answerFiles[i].split(application.id + '/')[1],
            status: 'done',
            url: d,
            old: true,
            oldVoucher: answerFiles[i],
          };
        });

        setCurrentFileAnswer(aux2);
      }
    };
    loadBankAnswerFiles();
  }, [application, currentBankAnswer, firebase.getDownloadURL]);

  /**
   * Permite la apertura de archivos PDF.
   */
  const openFiles = () => {
    currentFileAnswer.forEach((file) => {
      window.open(file.url);
    });
  };

  // Renderizar componente
  return (
    <div id={'taken-answer'}>
      <div className={'first'}>
        <h2>Datos del Crédito de Consumo</h2>
        <div className="data">
          <div>
            <span className="title">Banco</span>
            <span>{authUser.bankName}</span>
          </div>
          <div>
            <span className="title">Monto del Crédito</span>
            <span>${numberWithPoints(application.get('credito'))}</span>
          </div>
          <div>
            <span className="title">Cuotas</span>
            <span>{application.get('plazo')}</span>
          </div>
          <div>
            {application.get('fechaPrimerPago') ? (
              <>
                <span className="title">Fecha Primera Cuota</span>
                <span>
                  {moment(application.get('fechaPrimerPago').toDate()).format(
                    DATE_FORMAT
                  )}
                </span>
              </>
            ) : (
              <>
                <span className="title">Crédito Bullet</span>
                <span>Un Solo Pago Final</span>
              </>
            )}
          </div>
        </div>
      </div>
      <div className={'second'}>
        <h2>Detalle del Crédito</h2>
        <div className="data">
          <div>
            <span className="title">Tasa Mensual</span>
            <span>{currentBankAnswer.answer.tasaMensual}%</span>
          </div>
          <div>
            <span className="title">CAE Anual</span>
            <span>{currentBankAnswer.answer.cae1}%</span>
          </div>
          <div>
            <span className="title">Cuota Mensual</span>
            <span>$ {numberWithPoints(currentBankAnswer.answer.cuotaMensual1)}</span>
          </div>
          <div>
            <span className="title">Costo Total Crédito</span>
            <span>$ {numberWithPoints(currentBankAnswer.answer.costoTotal1)}</span>
          </div>
        </div>
      </div>
      <div className={'files'}>
        <span onClick={openFiles}>
          Descargar Oferta Banco <DonwloadIcon />
        </span>
      </div>
      <div className={'buttons'}>
        <Button onClick={() => reject(application, authUser)} className={'reject'}>
          Rechazar
        </Button>
        <Button onClick={() => report(application, authUser)} className={'send'}>
          Reportar
        </Button>
      </div>
    </div>
  );
};

export default TakenApplicationAnswerShowConsumo;
